import React from "react";

function InfoSidePanel({ ariaLabel, children }) {
    return (
        <aside className="community-info-panel" aria-label={ariaLabel}>
            <section className="community-info-plot">
                {children}
            </section>
        </aside>
    );
}

export default InfoSidePanel;
